const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- contact-dialog ---
let __fez_component_0;
{
const KINDS = [{ value: 'mobile', label: 'Mobile' }, { value: 'tel', label: 'Phone' }]
__fez_component_0 = class {
  PROPS = {
    contact: Object,
  }

  init(props) {
    // An Object prop left out arrives as `{}`.
    const contact = props.contact?.ref ? props.contact : null
    this.state.contact = contact
    this.state.kinds = KINDS
    this.state.lastKey = 0
    this.state.emails = (contact?.emails?.length ? contact.emails : ['']).map((value) => ({ key: this.nextKey(), value }))
    this.state.phones = (contact?.phones || []).map((phone) => ({ key: this.nextKey(), kind: phone.kind, number: phone.number }))
    this.state.errors = {}
    this.state.saving = false
  }

  nextKey() {
    this.state.lastKey += 1
    return this.state.lastKey
  }

  // Inputs are named by row key (formData keeps only the last value of a repeated name), so the
  // rows read their typed values back before one is added or removed.
  sync() {
    const form = this.formData(this.root.querySelector('form'))
    this.state.emails = this.state.emails.map((row) => ({ ...row, value: form[`email_${row.key}`] ?? row.value }))
    this.state.phones = this.state.phones.map((row) => ({
      ...row,
      kind: form[`phone_kind_${row.key}`] || row.kind,
      number: form[`phone_number_${row.key}`] ?? row.number,
    }))
  }

  addEmail() {
    this.sync()
    this.state.emails = [...this.state.emails, { key: this.nextKey(), value: '' }]
  }

  removeEmail(key) {
    this.sync()
    this.state.emails = this.state.emails.filter((row) => row.key !== key)
  }

  addPhone() {
    this.sync()
    this.state.phones = [...this.state.phones, { key: this.nextKey(), kind: 'mobile', number: '' }]
  }

  removePhone(key) {
    this.sync()
    this.state.phones = this.state.phones.filter((row) => row.key !== key)
  }

  async save(event) {
    event.preventDefault()
    this.sync()
    const form = this.formData(event.target)
    const payload = {
      name: form.name || '',
      emails: this.state.emails.map((row) => row.value.trim()).filter(Boolean),
      phones: this.state.phones.filter((row) => row.number.trim()).map((row) => ({ kind: row.kind, number: row.number.trim() })),
      notes: form.notes || '',
    }
    const contact = this.state.contact
    this.state.saving = true
    try {
      await window.App.api(contact ? `contact/${contact.ref}/update` : 'contact/create', payload)
      window.Dialog.close(true)
    } catch (error) {
      this.state.errors = error.details || {}
    } finally {
      this.state.saving = false
    }
  }

  async remove() {
    const ref = this.state.contact.ref
    const ok = await window.Dialog.confirm({ title: 'Delete contact?', text: 'Sending to one of its addresses adds it back.', confirm: 'Delete', danger: true })
    if (!ok) return
    await window.App.api(`contact/${ref}/delete`)
    window.Dialog.close(true)
  }

  CSS = `:fez {
display:block;form{display:grid;gap:var(--space-4)}.section{display:grid;gap:var(--space-2)}.section h3{margin:0;color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.entry{display:flex;align-items:flex-start;gap:var(--space-2)}.entry-kind{flex:0 0 120px}.entry-value{flex:1;min-width:0}.entry-add{justify-self:start}.actions-spacer{flex:1}
}`

  HTML = `<form onsubmit="fez.save(event)" novalidate>
<ui-input name="name" label="Name" value={state.contact?.name || ''} placeholder="Ana Horvat" error={state.errors.name} autofocus></ui-input>

<div class="section">
<h3>Emails</h3>
{#each state.emails as row, index}
<div class="entry" key={row.key}>
<div class="entry-value">
<ui-input name="email_{row.key}" type="email" value={row.value} placeholder="ana@example.com" error={index === 0 ? state.errors.emails : undefined}></ui-input>
</div>
<ui-button variant="ghost" icon="x" title="Remove" onclick="fez.removeEmail({row.key})"></ui-button>
</div>
{/each}
<span class="entry-add"><ui-button size="sm" variant="ghost" icon="plus" label="Add email" onclick="fez.addEmail()"></ui-button></span>
</div>

<div class="section">
<h3>Phones</h3>
{#each state.phones as row, index}
<div class="entry" key={row.key}>
<div class="entry-kind">
<ui-select name="phone_kind_{row.key}" :options="state.kinds" value={row.kind}></ui-select>
</div>
<div class="entry-value">
<ui-input name="phone_number_{row.key}" type="tel" value={row.number} placeholder="+385 91 555 0101" error={index === 0 ? state.errors.phones : undefined}></ui-input>
</div>
<ui-button variant="ghost" icon="x" title="Remove" onclick="fez.removePhone({row.key})"></ui-button>
</div>
{/each}
<span class="entry-add"><ui-button size="sm" variant="ghost" icon="plus" label="Add phone" onclick="fez.addPhone()"></ui-button></span>
</div>

<ui-textarea name="notes" label="Notes" rows="3" autogrow value={state.contact?.notes || ''} error={state.errors.notes}></ui-textarea>

<div class="dialog-actions">
{#if state.contact}
<ui-button variant="danger-ghost" icon="trash" label="Delete" onclick="fez.remove()"></ui-button>
{/if}
<span class="actions-spacer"></span>
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
<ui-button type="submit" variant="primary" label="Save" :loading="state.saving"></ui-button>
</div>
</form>`
};
}

Fez('contact-dialog', __fez_component_0);

export default __fez_component_0;
